import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';

import {SafeHtmlPipe,SafePipe,HighlightSearchPipe,DateAgoPipe,NamePipe,FolderItem} from './pipes';
import { KbArticlesCreateComponent, StatusPopupCreate } from './kb-articles/kb-articles-create/kb-articles-create.component';
import {MatButtonModule} from '@angular/material/button';
import { MatInputModule} from '@angular/material/input';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatDialogModule} from '@angular/material/dialog';
import { MatTooltipModule} from '@angular/material/tooltip';
import {BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatFormFieldModule } from '@angular/material/form-field';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import {DialogOverviewExampleDialog} from './sidenav/sidenav.component'
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {SidenavComponent } from './sidenav/sidenav.component';
import {MenuListItemComponent } from './sidenav/menu-list-item/menu-list-item.component';
import {HeaderComponent } from './header/header.component';
import {KbArtilesSingleComponent, StatusPopup } from './kb-articles/kb-articles-display/kb-articles-display.component';
import {HomeComponent } from './home/home.component';
import {FooterComponent } from './footer/footer.component';
import {ClipboardModule } from 'ngx-clipboard';
import {RouterModule, Router, UrlSerializer } from '@angular/router';
import {DatePipe } from '@angular/common';
import {DashboardModule } from './dashboard/dashboard.module';
import {CommonInterceptor } from './shared/interceptors/common.interceptor';
import { NotificationComponent } from './notification/notification.component';
import { TextEditorComponent } from './kb-articles/text-editor/text-editor.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { KbArticlesFolderRestoreComponent } from './kb-articles/kb-articles-folder-restore/kb-articles-folder-restore.component';
import {MatTableModule } from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    HighlightSearchPipe,
    SafePipe,
    DateAgoPipe,
    NamePipe,
    FolderItem,
    KbArticlesCreateComponent,
    SidenavComponent,
    MenuListItemComponent,
    HeaderComponent,
    DialogOverviewExampleDialog,
    KbArtilesSingleComponent,
    HomeComponent,
    FooterComponent,
    NotificationComponent,
    TextEditorComponent,
    StatusPopup,
    StatusPopupCreate,
    KbArticlesFolderRestoreComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatIconModule,
    MatTooltipModule,
    MatListModule,//REQUIRED FOR MATSIDENAV
    MatDialogModule,
    MatToolbarModule,
    ClipboardModule,
    DashboardModule,
    DragDropModule,
    MatTableModule,
    MatPaginatorModule
  ],
  providers: [
        DatePipe,
        {provide:HTTP_INTERCEPTORS,useClass:CommonInterceptor,multi:true}

     ],
  bootstrap: [AppComponent]
})
export class AppModule { }
